/**
 * NOTES STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getNotes,
    getNote,
    printNote,
    createNotes,
    updateNotes,
    deleteNotes,
    patchModuleNote,
    deleteModuleNote,
    createModuleNote,
} from "Core/entities/config/api.notes";

const state = {
    page: {},
    form: {},
    notes: [],
    note_options: [],
    selectedNote: {
        note_id: null,
        company_id: "",
        note_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        note_details: [],
    },
    notes_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_notes: {
        note_id: {
            name: "note_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        object_ref: {
            name: "object_ref",
            rules: "trim|max_length[10]|required",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        object_id: {
            name: "object_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        note: {
            name: "note",
            rules: "trim|required",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    notes: (state) => {
        return state.notes;
    },
};

// actions
const actions = {
    async fetchNotes({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getNotes({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageNotes", response.data.page);
                }

                if (body.options) {
                    commit("setFePartOptions", response.data.fe_parts);
                    commit("setNotesOptions", response.data.notes);
                } else {
                    commit("setNotes", response.data.notes);
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchNote({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getNote(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedNote", response.data.note);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printNote({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printNote(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveNote({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["note_id"] === "undefined" || body["note_id"] == null || body["note_id"] == "") {
                delete body["note_id"];
                response = await createNotes({ body: body, headers: config.headers });
            } else {
                let note_id = body["note_id"];
                delete body["note_id"];
                response = await updateNotes({ body: body, headers: config.headers }, note_id);
            }

            if (typeof response !== "undefined" && response.data) {
                commit("mutateCustomer", { property: "notes", with: response.data.notes });
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteNote({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteNotes(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
    async saveModuleNote({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["note_id"] === "undefined" || body["note_id"] == null || body["note_id"] == "") {
                delete body["note_id"];
                let module_id = body["module_id"];
                delete body["module_id"];
                response = await createModuleNote({ body: body, headers: config.headers }, module_id);
            } else {
                let note_id = body["note_id"];
                let module_id = body["module_id"];
                delete body["module_id"];
                delete body["note_id"];
                response = await patchModuleNote({ body: body, headers: config.headers }, note_id, module_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("patch response error");
                return;
            }
        } catch (error) {
            console.log("patch error");
            return;
        }
    },
    async removeModuleNote({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };
            let note_id = body["note_id"];
            let module_id = body["module_id"];
            delete body["module_id"];
            delete body["note_id"];
            response = await deleteModuleNote({ body: body, headers: config.headers }, note_id, module_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageNotes(state, page) {
        state.page = page;
    },
    setNotes(state, notes) {
        state.notes = notes;
    },
    setNotesOptions(state, notes) {
        state.note_options = notes;
    },
    setSelectedNote(state, note) {
        state.selectedNote = note;
    },
    resetSelectedNote(state) {
        for (const key in state.selectedNote) {
            if (key in state.rules_notes) {
                state.selectedNote[key] = state.rules_notes[key].default_value == "null" ? null : state.rules_notes[key].default_value;
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
